import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">

        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img
              src="img/about.jpg"
              className="img-responsive"
              alt="Sander Conn Ødegaard"
            />
          </div>

          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Me</h2>
              <p>{props.data ? props.data.paragraph : "Loading..."}</p>
            </div>
          </div>
        </div>

        <div className="row hobbies-section text-center">
          <div className="col-md-12 hobbies-title">
            <h5>Outside of Coding</h5>
            <br />
          </div>

          {props.data?.hobbies
            ? props.data.hobbies.map((hobby, i) => (
                <div
                  key={`${hobby.title}-${i}`}
                  className="col-xs-6 col-md-3"
                >
                  <span className="feature-emoji">{hobby.icon}</span>
                  <h3>{hobby.title}</h3>
                  <p>{hobby.text}</p>
                </div>
              ))
            : null}
        </div>

      </div>
    </div>
  );
};